<script lang="ts" setup>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import { authStore } from "@/store/auth";

const route = useRoute();
const router = useRouter();

const productAssetSuffix = computed(() => authStore.productAssetSuffix);
const mascotImage = computed(() =>
  require("@/assets/svg/caikuma_send_message" +
    authStore.productAssetSuffix +
    ".svg")
);
const orderReserveCompletedRoute = computed(() => ({
  name: "OrdersReserveCompleted",
  params: { applicationId: route.params.applicationId }
}));

function onClickBack() {
  router.back();
}
</script>

<template>
  <Header>
    <template v-slot:left>
      <FeatherIcon icon="chevron-left" @click="onClickBack" />
    </template>
    カレンダー登録
  </Header>

  <div>
    <div
      class="d-flex align-items-center justify-content-center flex-column mt-2 mb-4"
    >
      <img width="114" :src="mascotImage" />
      <div class="mt-2 text-black text-weight-600 text-center">
        お仕事の確定おめでとうございます！
      </div>
    </div>
    <div
      class="mt-4 mb-3 pt-2 px-3 pb-3"
      :class="`bg-banner${productAssetSuffix}`"
    >
      <div class="text-white text-center">check!</div>
      <div class="my-1 text-black text-weight-600 text-center">
        カレンダーに予定を登録してください
      </div>
    </div>
    <div class="mx-3">
      <div class="text-size-14 mb-3">
        お手持ちのカレンダーなどにお仕事の予定を登録してください。
      </div>
      <div class="text-size-12 mb-3">
        キャンセルの場合は、下記の手順が必要です。無断欠勤の場合は一時的にアカウントが利用停止となりますのでご注意ください。<br />
        ①すぐに事業所様に直接「電話」にて連絡<br />
        ②システム上で仕事をキャンセル
      </div>
      <AppButton class="w-100 mt-2" :to="orderReserveCompletedRoute"
        >完了</AppButton
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
.bg-banner {
  background-color: #fbce5a;
}

.bg-banner-caitech_pharmacist {
  background-color: #6ce0d7;
}
</style>
